import { render, staticRenderFns } from "./TutorDashboardScheduleLegend.vue?vue&type=template&id=60e42f4a&"
import script from "./TutorDashboardScheduleLegend.vue?vue&type=script&lang=js&"
export * from "./TutorDashboardScheduleLegend.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports